import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store' // Import Store in main.js
import { sync } from 'vuex-router-sync'
import VueObserveVisibility from 'vue-observe-visibility'
import GlobalMixin from './mixins/global.mixin'
import VueCookies from 'vue-cookies'

Vue.use(VueObserveVisibility)
Vue.config.productionTip = false

// Cookies
Vue.use(VueCookies)

// Global Mixin
Vue.mixin(GlobalMixin)

sync(store, router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

function hasQueryParams (route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  if (!hasQueryParams(to) && hasQueryParams(from) && to.name !== 'Authorize') {
    next({name: to.name, params: to.params, query: from.query})
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/main.js